import { render, staticRenderFns } from "./CategoryInfo.vue?vue&type=template&id=16f5affc&scoped=true"
import script from "./CategoryInfo.vue?vue&type=script&lang=js"
export * from "./CategoryInfo.vue?vue&type=script&lang=js"
import style0 from "./CategoryInfo.vue?vue&type=style&index=0&id=16f5affc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f5affc",
  null
  
)

export default component.exports